import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {IonicPageModule} from 'ionic-angular';
import {DaymenuCardComponent} from './daymenu-card/daymenu-card';
import {OrderCardComponent} from './order-card/order-card';
import {ShiftSelectorComponent} from './shift-selector/shift-selector';
import {TextInputDirective} from './text-input-directive/text-input-directive';

@NgModule({
  declarations: [
    DaymenuCardComponent,
    OrderCardComponent,
    ShiftSelectorComponent,
    TextInputDirective,
  ],
  imports: [
    IonicPageModule.forChild(DaymenuCardComponent),
    IonicPageModule.forChild(OrderCardComponent),
    IonicPageModule.forChild(ShiftSelectorComponent),
    TranslateModule.forChild()
  ],
  exports: [
    DaymenuCardComponent,
    OrderCardComponent,
    ShiftSelectorComponent,
    TextInputDirective,
  ]
})
export class ComponentsModule {
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts